import React from 'react';
import { Link } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { push, useRouteMatch, route_path } from '../../app/route';
import { logoutAction } from '../auth/authSlice';
import { selectCurrentTenantId } from '../user/userSlice';
import { getTenantDetailUrl } from '../tenant/tenantSlice';
import { getRoleListUrl } from '../role/roleSlice';
import { getClientListUrl } from '../client/clientSlice';
import { getScopeListUrl } from '../scope/scopeSlice';
import { getMemberListUrl, selectCanListMembers } from '../member/memberSlice';

export function Home() {
  const dispatch = useAppDispatch();
  const tenant_id = useAppSelector(selectCurrentTenantId);
  const can_list_members = useAppSelector(selectCanListMembers);
  const match = useRouteMatch<{ tenant_id: string; }>();

  React.useEffect(() => {
    if (match.params.tenant_id !== tenant_id) {
      dispatch(push(route_path.home.replace(':tenant_id', tenant_id)));
    }
  }, [tenant_id, match.params.tenant_id, dispatch]);

  return (
    <div className="container">
      <h1>Home Page</h1>
      <ul className="list-group">
        <li className="list-group-item">
          <Link to="/login" onClick={() => dispatch(logoutAction())}>Logout</Link>
        </li>
        <li className="list-group-item">
          <Link to={getTenantDetailUrl(tenant_id, 'view')}>Tenant Info</Link>
        </li>
        <li className="list-group-item">
          <Link to={getRoleListUrl(tenant_id)}>Role</Link>
        </li>
        {can_list_members &&
        <li className="list-group-item">
          <Link to={getMemberListUrl(tenant_id)}>Member</Link>
        </li>}
        <li className="list-group-item">
          <Link to={getClientListUrl(tenant_id)}>Client</Link>
        </li>
        <li className="list-group-item">
          <Link to={getScopeListUrl(tenant_id)}>Scope</Link>
        </li>
      </ul>
    </div>
  );
}
